import React from "react";
import ReactPaginate from "react-paginate";
import "./Pagination.css";
import * as types from "types/Components/Common/Pagination";

function Paginator({
  totalRecords,
  recordPerPage,
  onPageChange,
  presentPage
}: types.TPaginationProps) {

  // select will be -1 of page
  const handlePageChange: types.ThandlePageChange = ({selected}) => {
    onPageChange(selected + 1)
  }

  return (
    <>
       {Math.ceil(totalRecords / recordPerPage) > 1 && recordPerPage <= totalRecords && (
      <div id="paginator" className={`tw-py-2`}>
      <ReactPaginate
        previousLabel={<svg width="7" height="10" viewBox="0 0 7 10" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M5.35608 1.00012L1.35608 5.00012L5.35608 9.00012" stroke="#DFE1E6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
        }
        nextLabel={<svg width="7" height="10" viewBox="0 0 7 10" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M1.00342 1.00012L5.00342 5.00012L1.00342 9.00012" stroke="#253858" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
        }
        nextLinkClassName=" tw-h-8 tw-w-8 tw-block tw-flex tw-items-center tw-rounded"
        previousLinkClassName=" tw-h-8 tw-w-8 tw-block tw-flex tw-items-center tw-rounded"
        previousClassName="tw-aspect-sqaure"
        breakLabel={"..."}
        breakClassName={"break-me"}
        pageCount={Math.ceil(totalRecords / recordPerPage)}
        marginPagesDisplayed={2}
        pageRangeDisplayed={5}
        onPageChange={handlePageChange}
        containerClassName={`pagination tw-items-center tw-space-x-1`} 
        activeClassName={"active"}
        renderOnZeroPageCount={null}  
       forcePage={(presentPage? (presentPage -1) : undefined) }
      />
    </div>)}
    </>
  
  );
}

export default Paginator;
